import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';
import { NotableClientCardProps } from '../NotableClientsCards';
import { NotableClientCardWrapper } from './NotableClientCardWrapper';
import { ClientInfoTooltip } from './ClientInfoTooltip';

export const NotableClientCardColumn: React.FC<NotableClientCardProps> = ({ notableClient }) => {
  const { enrichedDetails: { logo, name, industry, description } = {} } = notableClient;

  return (
    <NotableClientCardWrapper notableClient={notableClient}>
      <Stack gap="4" alignItems="center">
        {logo && <Image objectFit="contain" height="auto" width={48} src={logo} alt={name} />}
        <Stack withDivider alignItems="center">
          <Text fontWeight="bold">{name}</Text>
          <Stack alignItems="center" width="auto">
            <Text color="bodySecondary">{industry}</Text>
            <ClientInfoTooltip description={description} />
          </Stack>
        </Stack>
      </Stack>
    </NotableClientCardWrapper>
  );
};
